<template>
  <zm-select
    data-testid="checkout-select-42"
    ref='select'
    v-model="innerValue"
    v-bind="$attrs"
    v-on="{
      ...$listeners,
      input: handleSelectInput,
      change: () => {},
    }"
  >
    <template v-for="slot in Object.keys({...$scopedSlots, ...$slots})" :slot="slot" slot-scope="scope">
      <slot :name="slot" v-bind="scope"></slot>
    </template>
  </zm-select>
</template>
<script>
import ZmSelect from '@/components/zoom-ui-plus/select/zm-select.vue';
export default {
  name: 'zb-select',
  components: { ZmSelect },
  data() {
    return {
      innerValue: '',
      nextValue: ''
    };
  },
  props: {
    value: [String, Number, Boolean, Array],
    action: Function,
  },
  methods: {
    handleSelectInput() {
      this.$nextTick(async () => {
        this.nextValue = this.innerValue;
        this.innerValue = this.value;
        if(this.action) {
          await this.action.call(this, this.value, this.nextValue);
        }
        this.$emit('input', this.nextValue);
        this.innerValue = this.nextValue;
        this.$emit('change', this.nextValue);
      })
    },
    focus() {
      this.$refs.select.focus();
    }
  },
  watch: {
    value: {
      immediate: true,
      handler() {
        this.innerValue = this.value;
      },
    }
  }
}
</script>
